import $ from 'jquery';

function initialize (context) {
    $('.f-accordion li.f-wrap div.f-content:not(.active-content)', context).hide().each(function () {
        $(this).closest('.f-wrap').find('> .trigger').addClass('collapsed f-accordion-allow-animations');
    });
    $('.f-accordion li.f-wrap .trigger', context).on('click', function () {
        var $this = $(this);
        if (!$this.hasClass('collapsed')) {
            $this.addClass('collapsed');
            $this.next().slideUp();
        } else {
            var accordion = $this.closest('.f-accordion');
            accordion.find('li.f-wrap .trigger').addClass('collapsed');
            $this.removeClass('collapsed');
            var opened = accordion.find('li.f-wrap div.f-content:visible'),
                scrollHeightDifference = ($('.navigation.sticky-top').outerHeight() || 0) * 1; // The height of other animated panels we need to take into account when scrolling

            // Close open panels and Open the clicked panel
            opened.slideUp();
            $this.next().slideDown();

            // Scroll to the opened panel
            $('html, body').animate({
                scrollTop: $this.offset().top - scrollHeightDifference - (opened.length && opened.offset().top < $this.offset().top ? (opened.outerHeight() || 0) : 0)
            }, 500);
        }
        return false;
    });
}

export default {initialize};